import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const ViewExcludeIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="viewExclude" ref={ref} {...props}>
      <path d="M22.75,10.26V18A3.76,3.76,0,0,1,19,21.7H9.21A3.76,3.76,0,0,1,5.46,18v-.46h9.33a3.76,3.76,0,0,0,3.75-3.75V6.51H19A3.76,3.76,0,0,1,22.75,10.26Zm-8-8H5A3.76,3.76,0,0,0,1.25,6.05v7.69A3.76,3.76,0,0,0,5,17.49h.46V10.26A3.76,3.76,0,0,1,9.21,6.51h9.33V6.05A3.76,3.76,0,0,0,14.79,2.3Z" />
    </Icon>
  ),
) as IconWithRender;

ViewExcludeIcon.displayName = 'ViewExcludeIcon';
ViewExcludeIcon.renderIcon = (props) => <ViewExcludeIcon {...props} />;
export default ViewExcludeIcon;
